import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { TextInput, Button } from "flowbite-react";
import { useGetData } from "../../../../../hooks/useGetData";
import { useMutationData } from "../../../../../hooks/useMutationData";
import { EvaluadoInterface } from "../../../../../interfaces/EvaluadoInterface";
import Header from "../../../../../components/HeaderForms/HeaderForms";
import { ThemeContext } from "../../../../../components/ThemeContext/ThemeContext";

export const AutorizacionOECrearScreen = () => {
  const { isDarkMode } = useContext(ThemeContext);
  const tituloFormulario = "AUTORIZACIÓN AL PROCESO DE OTRAS EVALUACIONES";

  const [formData, setFormData] = useState({
    date: "",
  });

  const { evaluadosList_id } = useParams<{ evaluadosList_id: string }>();
  const { control, handleSubmit } = useForm();

  const mutateFechaOE = useMutationData({
    url: `/fechas_oe/${evaluadosList_id}`,
    reload: ["evaluado", `${evaluadosList_id}`, "fechas_oe"],
  });

  const queryEvaluado = useGetData<EvaluadoInterface>({
    url: `/evaluado/${evaluadosList_id}`,
    name: ["evaluado"],
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const navigate = useNavigate();

  return (
    <div className={`min-h-screen ${isDarkMode ? "bg-gray-900" : "bg-gray-50"}`}>
      <div className="container mx-auto p-4">
        <form
          onSubmit={handleSubmit((data) => {
            console.log(data);

            // Aseguramos que los valores seleccionados se incluyan
            const formData = {
              ...data,
            };

            // Mutación para guardar la Fecha de Otras Evaluaciones
            mutateFechaOE.mutate(
              {
                data: { autorizacion_oe: data.autorizacion_oe },
                tipo: "post",
              },
              {
                onSuccess: () => {
                  navigate(`/otras_evaluacionesLinea/${evaluadosList_id}`);
                },
                onError: (error) => {
                  console.error(
                    "Error al guardar Fecha de Otras Evaluaciones:",
                    error
                  );
                },
              }
            );
          })}
          className={`max-w-4xl mx-auto rounded-lg shadow-lg overflow-hidden ${isDarkMode ? "bg-gray-800" : "bg-white"}`}
        >
          {/* Header */}
          <Header titulo={tituloFormulario} />

          {/* Contenido del formulario */}
          <div className="p-6">
            <div className="text-center mb-8">
              <div className="flex justify-left items-center gap-2 mb-4">
                <p className={`mt-3 ${isDarkMode ? "text-gray-300" : "text-black"}`}>Ciudad de México a</p>
                <Controller
                  name="autorizacion_oe"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <TextInput
                      id="autorizacion_oe"
                      type="date"
                      {...field}
                      className={`text-left w-auto border rounded ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-900 border-gray-300"}`}
                    />
                  )}
                />
              </div>
              <h2 className={`text-xl font-bold mb-4 flex items-center ${isDarkMode ? "text-white" : ""}`}>
                AUTORIZACIÓN AL PROCESO DE EVALUACIONES DE OTRAS EVALUACIONES
              </h2>
            </div>

            <div className="space-y-6">
              <div className="flex items-start">
                <span className={`mr-2 ${isDarkMode ? "text-gray-200" : ""}`}>Yo</span>
                <TextInput
                  type="text"
                  name="name"
                  value={`${queryEvaluado.data?.nombre || ""} ${
                    queryEvaluado.data?.apellido_paterno || ""
                  } ${queryEvaluado.data?.apellido_materno || ""}`}
                  onChange={handleInputChange}
                  className={`flex-1 mx-2 ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600" : "bg-white text-gray-900 border-gray-300"}`}
                />
                <span className={`ml-2 ${isDarkMode ? "text-gray-200" : ""}`}>
                  , autorizo que me aplique todas las Otras Evaluaciones
                </span>
              </div>
              <p className={`text-justify ${isDarkMode ? "text-gray-200" : ""}`}>
                así como todas las necesarias para el proceso de evaluación, etc.
                Asimismo, autorizo a la empresa SKA TRACKING AND SECURITY S.A. de
                C.V. para que proporcione toda la información y documentación que
                derive de las evaluaciones de pruebas de confianza que me
                realicen.
              </p>
              <p className={`text-justify ${isDarkMode ? "text-gray-200" : ""}`}>
                En este acto autorizo y conozco el aviso de privacidad el cual se
                encuentra publicado en
                https://skyangel.com.mx/avisodeprivacidad.htlm, por lo cual en
                este acto consiento que SKA TRACKING AND SECURITY S.A. de C.V.
                podrá recabar mis datos personales de conformidad con los términos
                establecidos en dicho aviso.
              </p>

              <p className={`text-justify ${isDarkMode ? "text-gray-200" : ""}`}>
                Bajo protesta de decir verdad hago constar que los datos
                proporcionados en el proceso de evaluación son verdaderos.
              </p>

              <div className="mt-12 text-center">
                <p className={`mb-8 font-bold ${isDarkMode ? "text-white" : ""}`}>ATENTAMENTE</p>
                <div className={`w-64 mx-auto pt-2 ${isDarkMode ? "border-t border-white" : "border-t border-black"}`}>
                  <p className={`text-sm ${isDarkMode ? "text-gray-300" : ""}`}>NOMBRE Y FIRMA</p>
                </div>
              </div>
            </div>
          </div>

          {/* Botones */}
          <div className="mt-4 mb-4 px-4">
            <div className="flex justify-between">
              <Button
                onClick={() => {
                  window.scrollTo(0, 0);
                  navigate(-1);
                }}
                className={`ml-2 ${isDarkMode ? "bg-red-600 hover:bg-red-800 text-white" : "bg-red-500 text-white"}`}
              >
                Regresar
              </Button>
              <Button
                type="submit"
                className={`ml-2 ${isDarkMode ? "bg-green-600 hover:bg-green-800 text-white" : "bg-green-500 text-white"}`}
              >
                {" "}
                Guardar{" "}
              </Button>
            </div>
          </div>

          {/* Footer */}
          <div className={`h-12 mt-8 flex items-center justify-center ${isDarkMode ? "bg-blue-900" : "bg-customBlue"}`}>
            <p className="text-sm text-white px-4">
              <span className="font-bold">DOCUMENTO CONFIDENCIAL</span>, prohibido
              su reproducción, copia o sacar este documento de las Instalaciones
              de Skyangel
            </p>
          </div>
        </form>
      </div>

    </div>
  );
};
